import React from "react";

const About = () => {
  const [header] = React.useState({
    subHeader: "About Me",
    text: "I am a microbiologist with a BSc (Hons) degree and expertise in multiple areas of the field. I also have experience in web and mobile app development, which allows me to approach problems from multiple angles. I am currently working as a medical microbiologist and constantly seeking new challenges and opportunities to expand my skills.",
  });
  const [state] = React.useState([
    { id: 1, title: "Name:", text: "Usman Ali" },
    { id: 2, title: "Email:", text: "usman.ali0@yahoo.com" },
    { id: 3, title: "Phone:", text: "+92 300 7007560" },
    { id: 4, title: "Linkedin", text: "Usman Ali   " },
  ]);
  return (
    <div className="about">
      <div className="container">
        <div className="common">
          <h1 className="mainHeader">{header.subHeader}</h1>
          <p className="mainContent">{header.text}</p>
          <div className="commonBorder"></div>
        </div>
        <div className="row  h-650 alignCenter">
          <div className="col-6">
            <div className="about__img" data-aos="zoom-in-right">
              <img src="/images/1.1.png" alt="man" />
            </div>
          </div>
          <div className="col-6">
            <div className="about__info">
              <h1>Hi There</h1>
              <div className="about__info-p1">
                As a highly qualified and skilled microbiologist and web/mobile
                app developer, I am excited to connect with you and discuss how
                my diverse skill set can benefit your project or organization.
                <br />
                My Bachelor of Science (Honours) in Microbiology and expert
                knowledge in various areas of the field make me a valuable asset
                for any project that requires a deep understanding of
                microbiology. Additionally, my experience in web and mobile app
                development allows me to bring a unique perspective and offer
                innovative solutions to problems.
              </div>
              <div className="about__info-p2">
                Whether you need assistance with a microbiology-related project
                or are looking for a web/mobile developer to bring your vision
                to life, I am confident that my skills and dedication to
                excellence will make me a valuable addition to your team.
                <br />
                <br />
                Don't hesitate – connect with me today and let's discuss how we
                can work together to achieve your goals!
              </div>
              <div className="info__contacts">
                <div className="row">
                  {state.map((info) => (
                    <div className="col-6">
                      <strong>{info.title}</strong>
                      <p data-aos="fade-left"
     data-aos-anchor="#example-anchor"
     data-aos-offset="500"
     data-aos-duration="500">{info.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
